// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"style-module_warningIcon__2Szae8qgFGVVi83-DS0yCA"};